import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import {
  leaderboardTotalProfit as leaderboardTotalProfitQuery,
  leaderboardHPRevenue as leaderboardHPRevenueQuery,
  leaderboardEmployeeSatisfaction as leaderboardEmployeeSatisfactionQuery,
  leaderboardClientSatisfaction as leaderboardClientSatisfactionQuery,
} from '../graphql/queries'

export const useLeaderboard = () => {
  const client = useMemo(() => generateClient(), [])
  const getTotalProfit = useCallback(
    async (offeringId, year) => {
      return client.graphql({
        query: leaderboardTotalProfitQuery,
        variables: { offeringId, year },
      })
    },
    [client],
  )

  const leaderboardHPRevenue = useCallback(
    async (offeringId) => {
      return client.graphql({
        query: leaderboardHPRevenueQuery,
        variables: { offeringId },
      })
    },
    [client],
  )

  const leaderboardEmployeeSatisfaction = useCallback(
    async (offeringId) => {
      return client.graphql({
        query: leaderboardEmployeeSatisfactionQuery,
        variables: { offeringId },
      })
    },
    [client],
  )

  const leaderboardClientSatisfaction = useCallback(
    async (offeringId) => {
      return client.graphql({
        query: leaderboardClientSatisfactionQuery,
        variables: { offeringId },
      })
    },
    [client],
  )

  return {
    getTotalProfit,
    leaderboardHPRevenue,
    leaderboardEmployeeSatisfaction,
    leaderboardClientSatisfaction,
  }
}
